import {
  setMessageLog,
  setScheduled,
  setLoading,
  setScheduledLoading,
  setError,
  setPagination,
  scheduledSmsSent,
  smsRescheduled,
  scheduleCancelled,
} from "../slices/message";
import axios from "axios";

export const clearMessageLog = () => (dispatch) => {
  dispatch(setMessageLog([]));
};

export const getMessageLog = (page) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get(`/api/sms/get-log/${page}/${10}`);
    const { messageLog } = data;

    dispatch(setMessageLog(messageLog.messages));
    dispatch(setPagination(messageLog.pagination));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const searchMessageLog = (searchBy, searchValue, dateFrom, dateTo, page) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.post(`/api/sms/search-log`, {
      searchBy,
      searchValue,
      dateFrom,
      dateTo,
      page,
      perPage: 10,
    });
    const { messageLog } = data;

    dispatch(setMessageLog(messageLog.messages));
    dispatch(setPagination(messageLog.pagination));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const getScheduledMessages = () => async (dispatch) => {
  dispatch(setScheduledLoading());
  try {
    const { data } = await axios.get(`/api/sms/get-scheduled/`);
    //console.log("Scheduled Messages Data: ", data);
    const { scheduled } = data;
    dispatch(setScheduled(scheduled));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const sendScheduledMessageNow = (id, smsData) => async (dispatch) => {
  try {
    await axios.post(`/api/sms/send-scheduled-now/${id}`, smsData);
    //console.log("Scheduled Messages Data: ", data);
    //const { scheduled } = data;
    dispatch(scheduledSmsSent({ recipient: smsData.to, message: smsData.body, jobNumber: smsData.jobNumber }));
    dispatch(getScheduledMessages());
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const rescheduleMessage = (id, smsData) => async (dispatch) => {
  try {
    await axios.post(`/api/sms/reschedule/${id}`, smsData);
    dispatch(
      smsRescheduled({
        recipient: smsData.to,
        message: smsData.body,
        jobNumber: smsData.jobNumber,
        scheduledFor: smsData.scheduledFor,
      })
    );
    dispatch(getScheduledMessages());
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const cancelMessageSchedule = (id) => async (dispatch) => {
  try {
    await axios.post(`/api/sms/cancel-schedule/${id}`);
    dispatch(scheduleCancelled({ scheduleId: id }));
    dispatch(getScheduledMessages());
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};
